import React, { FC } from 'react';

import { useStyles2 } from '@grafana/ui';

import { css } from '@emotion/css';

import { Investigation } from 'types';

import { RerunInvestigationButton } from './RerunInvestigationButton';

// Component Props Interface
interface Props {
  investigation?: Investigation;
}

// Declare Component
export const Actions: FC<Props> = ({ investigation }) => {
  const styles = useStyles2(getStyles);

  return (
    <div className={styles.container}>
      <RerunInvestigationButton investigation={investigation} />
    </div>
  );
};

// Define CSS Styles
const getStyles = () => {
  return {
    container: css`
      display: flex;
      align-items: flex-end;
      min-height: 85px;
    `,
  };
};

// Export Component
export default Actions;
